// extracted by mini-css-extract-plugin
export default {"block":"InfoBlock_block__dMQrr","title":"InfoBlock_title__U6NvH","body":"InfoBlock_body__CLcdj"};